import { AuthGraphQLProvider } from '@codezo/auth';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<AuthGraphQLProvider uri={import.meta.env.VITE_GRAPHQL_ENDPOINT}>
			<App />
		</AuthGraphQLProvider>
	</React.StrictMode>
);
